import React from "react";
import { Icon, IconProps } from "../Icon";
/**
 * @group Icons
 */
export function ExposurePlus2Icon(props: IconProps) {
    return <Icon {...props} iconKey={"exposure_plus_2"}/>
}
